import { useEffect, useState } from "react";
import { getMyAssignments } from "../../../data/projectWeeklyClient.js";
import { groupAssignments } from "./myUpdateModel.js";

// Use the guided flow's exact membership, not the filtered reader population
// or elevated content capabilities. Identity changes hide the old count at once.
export function useMyUpdateCount(identity, currentWeek, refreshToken) {
  const [state, setState] = useState(null);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    if (!currentWeek) return;
    let active = true;
    const load = () => {
      Promise.resolve().then(() => getMyAssignments()).then(result => {
        if (active) setState({ identity, week: currentWeek, count: groupAssignments(result?.assignments).length });
      }).catch(error => {
        if (active) setState({ identity, week: currentWeek, error: error?.message || "Could not load your assignments." });
      });
    };
    load();
    const timer = window.setInterval(load, 60_000);
    window.addEventListener("focus", load);
    return () => { active = false; window.clearInterval(timer); window.removeEventListener("focus", load); };
  }, [identity, currentWeek, refreshToken, retry]);
  return { ...(state?.identity === identity && state.week === currentWeek ? state : {}), retry: () => setRetry(n => n + 1) };
}
